import { useState, useEffect } from 'react';
import { useGameState } from './hooks/useGameState';
import { useViewportMetrics } from './hooks/useViewportMetrics';
import ServiceIntro from './components/ServiceIntro';
import StartScreen from './components/StartScreen';
import TutorialScreen from './components/TutorialScreen';
import GameScreen from './components/GameScreen';
import ResultScreen from './components/ResultScreen';
import GameHeader from './components/GameHeader';
import ExitConfirmModal from './components/ExitConfirmModal';
import GameIntroOverlay from './components/GameIntroOverlay';

const GAME_INFO = {
  name: '순서 기억하기',
  tag: '단기기억',
};

export default function Home() {
  const [showIntroOverlay, setShowIntroOverlay] = useState(true);
  const metrics = useViewportMetrics();

  const {
    screen,
    currentSpan,
    stage,
    showingIndex,
    showingStep,
    isShowing,
    userSequence,
    isInputEnabled,
    tutorialPhase,
    message,
    score,
    maxSuccessSpan,
    layout,
    showExitModal,
    goToGameGuide,
    goToIntro,
    goToTutorial,
    goToGame,
    handleTutorialTilePress,
    handleGameTilePress,
    goToNext,
    openExitModal,
    closeExitModal,
    confirmExit,
  } = useGameState();

  useEffect(() => {
    if (screen === 'start') {
      setShowIntroOverlay(true);
    }
  }, [screen]);

  const showGameHeader = screen === 'start' || screen === 'tutorial' || screen === 'game';

  return (
    <div
      className="w-full bg-secondary-100 flex justify-center overflow-hidden"
      style={{ height: `${metrics.height}px` }}
    >
      <div className="w-full max-w-[430px] h-full bg-secondary-100 flex flex-col overflow-hidden relative game-no-scroll">
        {showGameHeader && (
          <GameHeader
            screen={screen}
            stage={stage}
            onClose={openExitModal}
          />
        )}

        <div className="flex-1 overflow-hidden">
          {screen === 'intro' && <ServiceIntro onStart={goToGameGuide} />}
          {screen === 'start' && <StartScreen onStart={goToTutorial} />}
          {screen === 'tutorial' && (
            <TutorialScreen
              layout={layout}
              showingIndex={showingIndex}
              showingStep={showingStep}
              isShowing={isShowing}
              onTilePress={handleTutorialTilePress}
              isInputEnabled={isInputEnabled}
              userSequence={userSequence}
              tutorialPhase={tutorialPhase}
            />
          )}
          {screen === 'game' && (
            <GameScreen
              span={currentSpan}
              layout={layout}
              showingIndex={showingIndex}
              isShowing={isShowing}
              showingStep={showingStep}
              onTilePress={handleGameTilePress}
              isInputEnabled={isInputEnabled}
              userSequence={userSequence}
              message={message}
            />
          )}
          {screen === 'result' && (
            <ResultScreen
              score={score}
              maxSuccessSpan={maxSuccessSpan}
              onNext={goToNext}
              onRetry={goToTutorial}
            />
          )}
        </div>

        {screen === 'start' && showIntroOverlay && (
          <GameIntroOverlay
            gameName={GAME_INFO.name}
            cognitiveTag={GAME_INFO.tag}
            onDismiss={() => setShowIntroOverlay(false)}
          />
        )}

        <ExitConfirmModal
          isOpen={showExitModal}
          onConfirm={confirmExit}
          onCancel={closeExitModal}
        />
      </div>
    </div>
  );
}